import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { generateTitle } from '@/utils/i18n.js';
export default {
  __name: 'MenuItem',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_svg_icon, {
        icon: __props.icon
      }, null, 8, ["icon"]), _createElementVNode("span", null, _toDisplayString(_unref(generateTitle)(__props.title)), 1)], 64);
    };
  }
};